import React from 'react';

const CashIcon = ({color = 'currentColor'}) => (
  <svg aria-hidden={true} width="28" height="28" fill="none" viewBox="0 0 24 24">
    <path stroke={color} strokeWidth={1} strokeLinecap="round" d="M8 7V6a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1M3 18v-7a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Zm8-3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"/> 
  </svg>
);

export default CashIcon;